import React from 'react';
import { motion } from 'framer-motion';

interface CompactFeatureCardProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  delay?: number;
}

/**
 * Compact feature card for service pages — neumorphic theme
 */
const CompactFeatureCard: React.FC<CompactFeatureCardProps> = ({
  icon,
  title,
  description,
  delay = 0,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay }}
      className="h-full"
    >
      <div
        className="h-full rounded-neu p-6 bg-neu-bg transition-all duration-300 ease-out hover:-translate-y-1"
        style={{
          boxShadow: '9px 9px 16px rgb(163,177,198,0.6), -9px -9px 16px rgba(255,255,255,0.5)',
        }}
        onMouseEnter={e => {
          (e.currentTarget as HTMLDivElement).style.boxShadow =
            '12px 12px 20px rgb(163,177,198,0.7), -12px -12px 20px rgba(255,255,255,0.6)';
        }}
        onMouseLeave={e => {
          (e.currentTarget as HTMLDivElement).style.boxShadow =
            '9px 9px 16px rgb(163,177,198,0.6), -9px -9px 16px rgba(255,255,255,0.5)';
        }}
      >
        {icon && (
          <div
            className="w-12 h-12 mb-5 rounded-full flex items-center justify-center text-neu-accent"
            style={{
              background: '#E0E5EC',
              boxShadow: 'inset 6px 6px 10px rgb(163,177,198,0.6), inset -6px -6px 10px rgba(255,255,255,0.5)',
            }}
          >
            {icon}
          </div>
        )}
        <h3 className="font-display text-lg font-semibold mb-3 text-neu-text">{title}</h3>
        <p className="text-neu-muted text-sm leading-relaxed">{description}</p>
      </div>
    </motion.div>
  );
};

export default CompactFeatureCard;
